/**
 * Відповідь `GET /services/reports/overview[?user=<uuid>][&period=…]` — огляд
 * «Робочого столу» одним запитом. Власник — `ReportContainer` бека
 * (`GetHomeOverviewAction`). Гроші — у базовій валюті тенанта (гривні), частки
 * — відсотки з одним знаком; `null` у частці — «немає основи», а не нуль.
 */

/** Пресети періоду рейтингів — білий список бека (`HomeOverviewBounds::PRESETS`). */
export const OVERVIEW_PERIODS = ['month', 'quarter', 'year'] as const

export type OverviewPeriod = (typeof OVERVIEW_PERIODS)[number]

export interface IOverviewKpiWindow {
    /** Створені заявки (за датою створення, зокрема програні). */
    created: number
    /** Виконані перевезення: не програні, розвантажені у вікні. */
    closed: number
    turnover: number
    profit: number
    margin: number | null
    /** Частка вчасних розвантажень серед заявок із ПЛАНом. */
    onTime: number | null
}

export interface IOverviewTrendPoint {
    year: number
    /** 1–12. */
    month: number
    count: number
    turnover: number
    profit: number
    margin: number | null
}

export interface IOverviewPipelineStage {
    code: string
    title: string
    count: number
}

export interface IOverviewUpcoming {
    uuid: string
    client: string | null
    kind: 'loading' | 'unloading'
    /** `РРРР-ММ-ДД`. */
    date: string
    from: string | null
    to: string | null
    status: { code: string; title: string; color: string | null }
}

export interface IOverviewLeader {
    user: { uuid: string; fullName: string | null; isActive: boolean }
    applications: number
    profit: number
    turnover: number
    margin: number | null
}

export interface IOverviewSourceFunnel {
    total: number
    new: number
    priced: number
    won: number
    lost: number
}

export interface IHomeOverview {
    scope: { kind: 'company' | 'employee'; user: { uuid: string; fullName: string | null } | null }
    period: { preset: OverviewPeriod; from: string; to: string }
    kpi: {
        current: IOverviewKpiWindow
        previous: IOverviewKpiWindow
        currentFrom: string
        previousFrom: string
        previousTo: string
    }
    /** 12 місяців до поточного включно. */
    trend: IOverviewTrendPoint[]
    pipeline: IOverviewPipelineStage[]
    schedule: {
        loadingToday: number
        loadingTomorrow: number
        unloadingToday: number
        unloadingTomorrow: number
        unloadingOverdue: number
    }
    upcoming: { items: IOverviewUpcoming[]; total: number }
    /** `null` — без права `logisticians_all` у того, хто дивиться. */
    leaderboard: IOverviewLeader[] | null
    clients: {
        items: Array<{ uuid: string; title: string; applications: number; profit: number }>
        other: { clients: number; applications: number; profit: number }
        clients: number
        profit: number
    }
    routes: { items: Array<{ from: string; to: string; applications: number; profit: number }>; routes: number }
    sources: {
        request: IOverviewSourceFunnel
        tender: IOverviewSourceFunnel
        offers: { request: number; tender: number; application: number }
    }
}
